const HabboID = {

    addNew : async() => {

        const btnHTML = document.getElementById("verifyNewHabbo");
        const inputHabboName = document.getElementById("habboName");
        const hotelInput = document.getElementById('hotel');
        const steps = document.getElementById("validateSteps");

        btnHTML.disabled = true;
        inputHabboName.disabled = true;

        await Api.post('/habboid', {habboName: inputHabboName.value, hotel: hotelInput.value}, (r) => {
            if (r.success) {
                steps.innerHTML = HabboID.renderSteps(r.code);
                Alert.push([{type: 'success', text: 'Se ha agregado un Habbo al proceso de verificación, completa los pasos para garantizar tu identidad.', icon: 'check'}]);
            } else {
                steps.innerHTML = "";
                switch (r.error.identifier) {
                    case 'habbo_not_found':
                        Alert.push([{type: 'danger', text: '¡Oops! El habbo que intentas vincular no ha podido ser recuperado.', icon: 'triangle-alert'}]);
                        break;
                    case 'already_verified':
                        Alert.push([{type: 'danger', text: '¡Oops! Ya has verificado previamente este usuario.', icon: 'triangle-alert'}]);
                        break;
                    case 'habbo_is_required':
                        Alert.push([{type: 'danger', text: '¡Oops! Es necesario que ingreses un Habbo a verificar.', icon: 'triangle-alert'}]);
                        break;
                    case 'internal_error':
                        Alert.push([{type: 'danger', text: '¡Oops! Ha ocurrido un error interno.', icon: 'triangle-alert'}]);
                        break;
                    default:
                        Alert.push([{type: 'danger', text: r.error.identifier, icon: 'triangle-alert'}]);
                        break;
                }
            }
        })

        btnHTML.disabled = false;
        inputHabboName.disabled = false;

    },

    renderSteps: (code) => {
        return `
           <div class="box box-biggest box-black">
                <div class="head">[VERIFICACIÓN] Completa verificación de identidad <span class="glyphicons glyphicons-magic-wand"></span></div>
                <div class="body text">
                    ¡Bien! Vamos a comenzar con el proceso de verificación de tu cuenta, para ello solo deberás completar exitosamente los siguientes pasos:
                    <br /><br />
                    <ul>
                        <li>1. Ingresa al hotel donde se encuentra registrado el usuario.</li>
                        <li>2. Inicia sesión con los datos de tu cuenta.</li>
                        <li>3. Ingresa al hotel, y dirigete a tu perfil.</li>
                        <li>4. Cambia tu misión con el siguiente código de verificación que te mostraremos a continuación:</li>
                    </ul>
                </div>

                <div class="body">
                    <p>Ingresa el siguiente código de verificación en tu cuenta, revisa que no cuente con espacios para asegurar
                    que la el proceso sea exitoso.</p>
                    <div style="display: flex;justify-content: center;align-items: center;margin-top:5px; margin-bottom: 5px;">
                        <input type="hidden" id="verificationCode" value="${code}">
                         <div id="code" style="background: #ececec; width: 200PX; font-size: 20PX; font-weight: 900; padding: 10px; border-radius: 4px; color: #95a5a6; text-align: center;">
                            ${code}
                        </div>
                    </div>
                </div>

                <div class="body text">
                    ¿Has seguido los pasos anteriores? Únicamente queda dar clic sobre el botón que se muestra abajo y podrás disfrutar de las ventajas de
                    tener un habbo verificado en la web.
                </div>

                <div class="body">
                    <button class="button green big large" onclick="HabboID.validateByCode('${code}');">Finalizar proceso de verificación</button>
                </div>
            </div>

        `;
    },

    renderEachPendingItem: async(data) => {
      let HTMLData = ``;
      data.map((pending) => {
          HTMLData += `
            <div style="display: flex; justify-content: space-between">
                <div style="display: flex;gap: 5px">
                    <img src=${`https://www.habbo.${pending?.hotel}/habbo-imaging/avatarimage?user=${pending?.habboName}&direction=3&head_direction=3&gesture=sml&action=wav&size=s`}  alt="Habtium">
                    <div style="display:flex; flex-direction: column;align-content: center">
                        <h1>${pending?.habboName} (${pending?.hotel})</h1>
                        <strong>${pending?.code}</strong>
                        <small style="font-size: 12px">Expira ${Time.getHTML(pending?.expiredAt)}</small>
                    </div>
                </div>
                <button class="button blue big" onclick="HabboID.validateByCode('${pending?.code}')">Validar</button>
            </div>
          `
      })
      return HTMLData;
    },

    renderPendings: () => {
        const pendingContainer = document.getElementById("pendingVerifications");

        Api.get('/habboid/pending', {}, async(r) => {
            if (r.success && r.data.length > 0) {
                const innerData = await HabboID.renderEachPendingItem(r.data);
                const template =  `
                    <div class="box box-biggest box-orange">
                        <div class="head">Habbos pendientes de verificar <span class="glyphicons glyphicons-clock"></span></div>
                        <div class="body" style="display: flex;flex-direction: column;gap:5px;">
                            ${innerData}
                        </div>
                    </div>
                `
                pendingContainer.innerHTML = template;
            } else
                pendingContainer.innerHTML = "";
        })
    },

    validateByCode: async(code) => {
        if (code.length > 0 ) {
            await Api.post('/habboid/verify', {code}, (r) => {
                if (r.success) {
                    Alert.push([{type: 'success', text: '¡Bien! Hemos logrado verificar tu identidad.', icon: 'check'}]);
                } else {
                    switch (r.error.identifier) {
                        case 'motto_not_found_verify_failed':
                            Alert.push([{type: 'danger', text: '¡Oops! No hemos logrado verificar tu identidad, verifica haber colocado exitosamente el código.', icon: 'triangle-alert'}]);
                            break;
                        case 'not_found_code':
                            Alert.push([{type: 'danger', text: '¡Oops! El código que intentas verificar no existe.', icon: 'triangle-alert'}]);
                            break;
                        case 'habbo_not_found':
                            Alert.push([{type: 'danger', text: '¡Oops! El habbo que intentas vincular no ha podido ser recuperado.', icon: 'triangle-alert'}]);
                            break;
                        case 'internal_error':
                            Alert.push([{type: 'danger', text: '¡Oops! Ha ocurrido un error interno.', icon: 'triangle-alert'}]);
                            break;
                        default:
                            Alert.push([{type: 'danger', text: r.error.identifier, icon: 'triangle-alert'}]);
                            break;
                    }
                }
                HabboID.renderPendings();
                HabboID.getHabbosVerifiedByMe();
            })
        }
    },

    validate: async(code) => {
       await HabboID.validateByCode(code);
    },

    renderHabboItem: (data) => {
      const favoriteTag = `
        <span style="font-size: 10px;background-color: #f27935;color:white;border-radius:5px;margin-left:5px;padding:2px;padding-left: 5px;padding-right: 5px;">
            Favorito
        </span>
      `;

      let HTMLData = ``;
      data.map(habbo => {
          HTMLData += `
            <tr>
                <td style="text-align: center;display: flex;justify-content: center;align-items: center;">
                    <img src=${`https://www.habbo.${habbo?.hotel}/habbo-imaging/avatarimage?user=${habbo?.habboName}&direction=3&head_direction=3&gesture=sml&action=wav&size=s`}  alt=${`${habbo.habboName}`}>
                     <span style="font-size: 10px;background-color: #eb9532;color:white;border-radius:5px;margin-left:5px;padding:2px;padding-left: 5px;padding-right: 5px;">
                        ${habbo?.hotel}
                    </span>
                </td>
                <td style="text-align: center;">${habbo.habboName} ${habbo.isFavorite == 1 || habbo.isFavorite == "1" ? favoriteTag : ""}</td>
                <td style="text-align: center;">
                    <button class="button blue big" onclick="HabboID.favorite(${habbo.id})">${habbo.isFavorite=="1" ? "Quitar favorito": "Favorito"}</button>
                    <button class="button red big" onclick="HabboID.delete(${habbo.id})">Eliminar</button>
                </td>
            </tr>
          `
      })
        return HTMLData;
    },

    getHabbosVerifiedByMe: async() => {
        const container = document.getElementById('habbosVerified');

        Api.get('/habboid', {}, async(r) => {
           if (r.success && r.data.length > 0) {
               const innerData = await HabboID.renderHabboItem(r.data);
               const template = `
                <div class="box box-biggest box-green">
                    <div class="head">Habbos vinculados <span class="glyphicons glyphicons-verify-check"></span></div>
                    <div class="body">
                        <table style="margin:-1px 0px 1px;">
                                <tr>
                                    <th style="text-align: center;">Visualización</th>
                                    <th style="text-align: center;">Nombre de usuario</th>
                                    <th style="text-align: center;">Acciones</th>
                                </tr>
                            <tbody>
                                ${innerData}
                            </tbody>
                    </div>
                </div>
               `
                container.innerHTML = template;
           } else
               container.innerHTML = "";
        });
    },

    favorite: async(id) => {
        Api.post('/habboid/favorite', {habbo_id: id}, (r) => {
            if (r.success) {
                Alert.push([{type: 'success', text: 'Has actualizado tu habbo marcado como favorito.', icon: 'check'}]);
                HabboID.getHabbosVerifiedByMe();
            } else {
                switch (r.error.identifier) {
                    case 'hotel_not_allowed':
                        Alert.push([{type: 'danger', text: '¡Ooops! Actualmente no puedes elegir un Habbo favorito que no sea del hotel español. ¡Estamos trabajando en ello!', icon: 'triangle-alert'}]);
                        break;
                    case 'habbo_not_found':
                        Alert.push([{type: 'danger', text: '¡Oops! El habbo que intentas vincular no ha podido ser recuperado.', icon: 'triangle-alert'}]);
                        break;
                    case 'internal_error':
                        Alert.push([{type: 'danger', text: '¡Oops! Ha ocurrido un error interno.', icon: 'triangle-alert'}]);
                        break;
                    default:
                        Alert.push([{type: 'danger', text: r.error.identifier, icon: 'triangle-alert'}]);
                        break;
                }
            }
        })
    },

    delete : async(id) => {
        Api.post('/habboid/delete', {habboverify_id: id}, (r) => {
           if (r.success) {
               Alert.push([{type: 'success', text: 'Has desvinculado exitosamente tu cuenta.', icon: 'check'}]);
               HabboID.getHabbosVerifiedByMe();
           } else {
               switch (r.error.identifier) {
                   case 'permissions_required':
                       Alert.push([{type: 'danger', text: '¡Ooops! No puedes eliminar este habbo verificado.', icon: 'triangle-alert'}]);
                       break;
                   default:
                       Alert.push([{type: 'danger', text: r.error.identifier, icon: 'triangle-alert'}]);
                       break;
               }
           }
        });
    }
}
